<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="value"
          :label="label"
          outlined
          class="DatepickerField"
          background-color="secondary lighten-1"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
        />
      </template>
      <v-date-picker :value="value" :active-picker.sync="activePicker" @change="save"/>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'Datepicker',
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    activePicker: null,
    date: null,
    menu: false
  }),
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = 'MONTH'))
    }
  },
  methods: {
    save(date) {
      this.$emit('input', date)
      this.$refs.menu.save(date)
    }
  }
}
</script>

<style lang="scss">
.DatepickerField fieldset {
  border: 0 !important;
}
</style>
